import { render } from "./SinglesFellowship.vue?vue&type=template&id=6e31cf78&scoped=true"
import script from "./SinglesFellowship.vue?vue&type=script&lang=js"
export * from "./SinglesFellowship.vue?vue&type=script&lang=js"

import "./SinglesFellowship.vue?vue&type=style&index=0&id=6e31cf78&scoped=true&lang=css"

import exportComponent from "C:\\Users\\ynyan\\Desktop\\官网\\YNOfficialwebsite\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e31cf78"]])

export default __exports__